import React, { useEffect, useState } from "react";
import { Input, Select } from "antd";

import PropertiesService from '@/services/PropertiesService'
import { useSearchParams } from "react-router-dom";

const SearchBar = ({ ...props }) => {
    const [provinces, setProvinces] = useState([])

    const [search, setSearch] = useState('')
    const [selectedProvince, setSelectedProvince] = useState('')
    const [selectedType, setSelectedType] = useState('')

    const [searchParams] = useSearchParams();

    useEffect(() => {
        PropertiesService.getFilter({ ParentCode: "J003" }).then(res => {
            setProvinces([{ Code: "", Name: "Tất cả tỉnh / thành phố" }, ...res.Data])
        })
    }, []);

    useEffect(() => {
        if (searchParams.get("inputSearch")) setSearch(searchParams.get("inputSearch"))
        if (searchParams.get("codeKhuVuc")) setSelectedType(searchParams.get("codeKhuVuc"))
        if (searchParams.get("codeTinh")) setSelectedProvince(searchParams.get("codeTinh"))
    }, [searchParams]);

    const handleSearch = () => {
        props.onSearch({
            inputSearch: search,
            codeKhuVuc: selectedType,
            codeTinh: selectedProvince
        });
    }
    return (
        <div className={"bg-white"}>
            <div className="container mx-auto flex items-center flex-wrap
             p-4">
                <div className={"p-2 flex h-14 w-full md:w-1/2 lg:w-2/5"}>
                    {/*searchtext*/}
                    <Input
                        allowClear
                        onChange={e => setSearch(e.target.value)}
                        value={search}
                        type="text"
                        placeholder="Tên khu công nghiệp"
                        className="flex-1 md:auto border border-gray-300 rounded-lg h-full focus:outline-none focus:ring focus:ring-cyan-200" />
                </div>
                {/*Types*/}
                <div className={"p-2 flex h-14 w-full md:w-1/2 lg:w-1/5"}>
                    <Select
                        className="w-full h-full border-none rounded-lg focus:outline-none focus:ring focus:ring-cyan-200"
                        showSearch
                        filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase())}
                        options={[
                            { value: '', label: "Tất cả vùng miền" },
                            { value: 'B', label: "Bắc" },
                            { value: 'N', label: "Nam" },
                            { value: 'T', label: "Trung" }
                        ]}
                        placeholder={"Tất vùng miền"}
                        onChange={(value) => setSelectedType(value)}
                        value={selectedType.toLocaleUpperCase()}
                    />
                </div>
                {/* Tỉnh/Thành phố */}
                <div className={"p-2 flex h-14 w-full md:w-1/2 lg:w-1/5"}>
                    <Select
                        className="w-full  h-full border-none rounded-lg focus:outline-none focus:ring focus:ring-cyan-200"
                        showSearch
                        placeholder="Tất cả tỉnh / thành phố"
                        filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase())}
                        options={provinces}
                        fieldNames={{ value: "Code", label: "Name" }}
                        onChange={(value, option) => setSelectedProvince(value)}
                        value={selectedProvince}
                    />
                </div>
                {/* Nút Tìm kiếm */}
                <div className={"p-2 flex h-14 w-full md:w-1/2 lg:w-1/5"}>
                    <button
                        onClick={handleSearch}
                        className="w-full h-full text-nowrap  font-bold  bg-gradient-to-l bg-primary hover:bg-primary-hover text-white rounded-lg py-2 transition">
                        Tìm kiếm
                    </button>
                </div>
            </div>
        </div>
    );
}
    ;

export default SearchBar;
